import moment, { Moment } from 'moment-timezone';

class DateProvider {
  public static today(): Moment {
    return moment().startOf('day');
  }
}

export default DateProvider;
